export const reviews = [
  {
    name: "Matt",
    date: "June 2026",
    text: "An absolute gem and easily the highlight of my trip. The room was gorgeous, private and secluded, with its own patio that made it feel like a peaceful retreat. I left wishing I could have stayed longer.",
  },
  {
    name: "Virginie",
    date: "February 2026",
    text: "This place is just amazing! Everything was perfect: the comfort, the decoration, the lighting, the amenities, the location, the kindness of the owners. One of the best stays of my life — and I travel a lot.",
  },
  {
    name: "Hallie",
    date: "November 2025",
    text: "The place was an oasis! The bed and bedding were divine — literally everything was perfect. So chic and comfortable. I'll be back for sure.",
  },
  {
    name: "Roxanne",
    date: "January 2026",
    text: "A well-thought-out funky design with higher-end materials. The king-size down pillow and comfy mattress were perfect. I don't usually gush giving reviews, but this is a gush-worthy property.",
  },
  {
    name: "Dominik",
    date: "March 2026",
    text: "Es war einfach alles perfekt! There couldn't have been a better place to start our honeymoon. Any questions were answered immediately over chat. We'll happily come back!",
  },
  {
    name: "Emily",
    date: "November 2025",
    text: "PERFECT for a weekend getaway, with everything we needed within walking distance — a cute cafe, a Starbucks and a store. A short drive to the beach and other attractions too.",
  },
];
